import styled from 'styled-components'

export default styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background: var(--very-light-blue);
  padding: 16px 24px;
  gap: 8px;

  > label {
    font: var(--600-16);
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 24px;
  }

  > button {
    background: var(--very-light-blue);
    margin-left: auto;
  }
`
